package ui.campaign.detailv2.editor

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import common.frontend.api.Io
import provider.*
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.globalViewModel
import tk.mallumo.compose.navigation.viewmodel.viewModel
import ui.GlobalVM

class CampaignEditorScope(
    val vm: CampaignEditorVM,
    val vmGlobal: GlobalVM,
    val action: (CampaignEditorVM.Action) -> Unit,

    val args: CampaignEditorArgs,
    val nav: Navigation,
    val login: Io.User,
    val display: CommonDisplayProvider,
    val externals: CommonExternalsProvider
) {

    init {
        vm.init(this)
    }

    companion object {
        @Composable
        fun rememberScope(): CampaignEditorScope {

            val account = LocalAccountProvider.current.current!!
            val nav = LocalNavigation.current
            val display = LocalDisplayProvider.current
            val externals = LocalExternalsProvider.current
            val args = LocalNavigationArgs.current.rememberArgs(CampaignEditorArgs::class)
            val vm = nav.viewModel(CampaignEditorVM::class, "${args.companyId}:${args.campaignId}")
            val vmGlobal = globalViewModel(GlobalVM::class)
            val action = CampaignEditorVM.Action.rememberAction(vm)

            return remember {
                CampaignEditorScope(
                    vm = vm,
                    vmGlobal = vmGlobal,
                    action = action,
                    args = args,
                    nav = nav,
                    login = account,
                    display = display,
                    externals = externals
                )
            }
        }
    }
}
